import { ThumbsUp, ThumbsDown, Heart, PartyPopper } from "lucide-react";

// Single source of truth for the feed reactions. `key` is the value stored in
// post.reactions[userId]; `countKey` is the denormalized field on
// post.reactionCounts. Order here is the on-screen button order.
export const REACTIONS = [
  {
    key: "like",
    label: "Like",
    countKey: "likes",
    Icon: ThumbsUp,
    activeClass: "bg-blue-50 border-blue-200 text-blue-700",
  },
  {
    key: "dislike",
    label: "Dislike",
    countKey: "dislikes",
    Icon: ThumbsDown,
    activeClass: "bg-rose-50 border-rose-200 text-rose-700",
  },
  {
    key: "heart",
    label: "Heart",
    countKey: "hearts",
    Icon: Heart,
    activeClass: "bg-pink-50 border-pink-200 text-pink-700",
  },
  {
    key: "party",
    label: "Party",
    countKey: "party",
    Icon: PartyPopper,
    activeClass: "bg-amber-50 border-amber-200 text-amber-700",
  },
];

export const REACTION_BY_KEY = Object.fromEntries(
  REACTIONS.map((r) => [r.key, r]),
);
